define('BluePoint.OrderTotalFix.MiniCart',
    [
        'jQuery',
        'underscore',
        'BluePoint.OrderTotalFix.Utils'
    ],
    function (
        $,
        _,
        Utils
    ) {

        'use strict';

        return {

            mountToApp: function mountToApp(container) {

                var cart = container.getComponent('Cart');

                if (!cart) {
                    console.log('Cart component not found');
                    return;
                }

                /*
                UPDATE MINI CART LINE UI
                */
                function updateMiniCartLineUI(line, totalQty) {

                    var quantity = Utils.getQuantity(line);
                    var schedule = Utils.getSchedule(line);

                    /*
                    SKIP NON QUANTITY PRICING ITEMS
                    */
                    if (!schedule || !schedule.length) {
                        return;
                    }

                    var tierPrice = Utils.getTierPrice(schedule, totalQty);
                    if (!tierPrice) {
                        return;
                    }

                    var basePrice = Utils.getBasePrice(schedule);
                    var itemId = line.item && line.item.internalid;
                    if (!itemId) {
                        return;
                    }

                    /*
                    GET MINI CART LINE
                    */
                    var $line = $('.header-mini-cart-item-cell[data-item-id="' + itemId + '"]');
                    if (!$line.length) {
                        return;
                    }

                    /*
                    GET MINI CART PRICE
                    */
                    var $price = $line.find('.header-mini-cart-item-cell-product-price');
                    if (!$price.length) {
                        return;
                    }

                    /*
                    UPDATE PRICE
                    */
                    $price.html('$' + tierPrice.toFixed(2));

                    /*
                    STRIKE PRICE
                    */
                    if (tierPrice < basePrice) {
                        if ($line.find('.bp-mini-old-price').length === 0) {
                            $price.append(
                                '<small class="bp-mini-old-price" ' +
                                'style="' +
                                'text-decoration:line-through;' +
                                'margin-left:5px;' +
                                'color:#999;">' +
                                '$' + basePrice.toFixed(2) +
                                '</small>'
                            );

                        } else {
                            $line.find('.bp-mini-old-price').html('$' + basePrice.toFixed(2));
                        }

                    } else {
                        $line.find('.bp-mini-old-price').remove();
                    }
                }

                /*
                UPDATE MINI CART SUMMARY UI
                */
                function updateMiniCartUI(pricingData) {
                    /*
                    UPDATE SUBTOTAL
                    */
                    $('.header-mini-cart-subtotal-amount')
                        .html(
                            '<span class="header-mini-cart-subtotal-amount-text">' +
                            'Subtotal' +
                            '</span> $' +
                            pricingData.frontendSubtotal.toFixed(2)
                        );

                    /*
                    SAVINGS MESSAGE
                    */
                    if ($('.bp-mini-savings').length === 0) {
                        $('.header-mini-cart-subtotal-amount')
                            .after(
                                '<div class="bp-mini-savings" ' +
                                'style="color:green;font-size:12px;margin-top:5px;">' +
                                'You saved $' +
                                pricingData.totalSavings.toFixed(2) +
                                '</div>'
                            );

                    } else {
                        $('.bp-mini-savings')
                            .html(
                                'You saved $' +
                                pricingData.totalSavings.toFixed(2)
                            );
                    }

                    /*
                    NEXT TIER MESSAGE
                    */
                    if (pricingData.nextTierMessage) {
                        if ($('.bp-mini-next-tier').length === 0) {
                            $('.bp-mini-savings')
                                .after(
                                    '<div class="bp-mini-next-tier" ' +
                                    'style="margin-top:5px;color:#d97706;font-size:12px;font-weight:600;">' +
                                    pricingData.nextTierMessage +
                                    '</div>'
                                );

                        } else {
                            $('.bp-mini-next-tier').html(pricingData.nextTierMessage);
                        }

                    } else {
                        $('.bp-mini-next-tier').remove();
                    }
                }

                /*
                APPLY MINI CART DISCOUNTS
                */
                function applyMiniCartDiscounts() {

                    cart.getLines().done(function (lines) {
                        try {
                            /*
                            CENTRALIZED PRICING
                            */
                            var pricingData = Utils.calculateTotals(lines);

                            /*
                            UPDATE MINI CART LINE UI
                            */
                            _.each(lines, function (line) {
                                updateMiniCartLineUI(line, pricingData.totalQty);
                            });

                            /*
                            UPDATE MINI CART SUMMARY
                            */
                            updateMiniCartUI(pricingData);

                        } catch (e) {
                            console.log('Mini Cart Discount Error =====>', e);
                        }
                    });
                }

                /*
                VERIFY MINI CART RENDER
                */
                function startMiniCartVerification() {

                    var attempts = 0;
                    var maxAttempts = 20;
                    var interval = setInterval(function () {

                        attempts++;

                        cart.getLines().done(function (lines) {
                            try {
                                var pricingData = Utils.calculateTotals(lines);
                                var expectedSubtotal = pricingData.frontendSubtotal.toFixed(2);
                                var renderedSubtotal = $.trim($('.header-mini-cart-subtotal-amount').text());
                                var subtotalMatched = renderedSubtotal.indexOf(expectedSubtotal) !== -1;

                                if (!subtotalMatched) {
                                    applyMiniCartDiscounts();

                                } else {
                                    clearInterval(interval);
                                }

                                /*
                                FAILSAFE
                                */
                                if (attempts >= maxAttempts) {
                                    clearInterval(interval);
                                }

                            } catch (e) {
                                console.log('Mini Cart Verification Error =====>', e);
                            }
                        });

                    }, 500);
                }

                /*
                INITIAL LOAD
                */
                setTimeout(function () {
                    applyMiniCartDiscounts();
                    startMiniCartVerification();
                }, 1500);

                /*
                REUSABLE REFRESH
                */
                function refreshMiniCartPricing() {
                    setTimeout(function () {
                        applyMiniCartDiscounts();
                        startMiniCartVerification();
                    }, 500);
                }

                /*
                CART EVENTS
                */
                cart.on('afterAddLine', refreshMiniCartPricing);
                cart.on('afterUpdateLine', refreshMiniCartPricing);
                cart.on('afterRemoveLine', refreshMiniCartPricing);
            }
        };
    }
);
